import React, { useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsReact from "highcharts-react-official";
import { ConfigProvider, Dropdown, Menu } from "antd";
import { useSelector } from "react-redux";
import workspaceService from "@services/workspace.service";
import performanceManagementService from "@services/performanceManagement.service";
import toast from "react-hot-toast";

HighchartsExporting(Highcharts);

const { SubMenu } = Menu;

Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
  },
});

const options = {
  exporting: {
    enabled: false,
  },
  title: {
    text: "",
    margin: 50,
    style: { fontSize: "2rem", fontWeight: "bold" },
  },
  chart: {
    zoomType: "x",
    style: {
      fontFamily: `Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
      "Helvetica Neue", Arial, "Noto Sans", sans-serif,
      "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
    },
    exporting: {
      enabled: false,
    },
  },
  credits: {
    enabled: false,
  },
  // colors: ["#2F5EC4", "#45a5f5"],
  plotOptions: {
    line: {
      lineWidth: 2,
      states: {
        hover: {
          lineWidth: 3,
        },
      },
      marker: {
        enabled: false,
      },
    },
  },
  yAxis: [
    {
      id: "left1",
      lineWidth: 1,
      title: {
        enabled: false,
      },
    },
    {
      id: "left2",
      title: {
        enabled: false,
      },
    },
    {
      id: "right1",
      lineWidth: 1,
      opposite: true,
      title: {
        enabled: false,
      },
    },
    {
      id: "right2",
      lineWidth: 0,
      opposite: true,
      title: {
        enabled: false,
      },
    },
  ],
  xAxis: [
    {
      id: "bottom1",
      type: "datetime",
      labels: {
        style: { fontWeight: "bold" },
        rotation: 45,
        // format: ""
      },
      lineWidth: 1,
      title: {
        enabled: false,
      },
    },
    {
      id: "bottom2",
      type: "datetime",
      labels: {
        style: { fontWeight: "bold" },
        rotation: 45,
        // format: ""
      },
      lineWidth: 1,
      title: {
        enabled: false,
      },
    },
  ],
  tooltip: {
    shared: true,
    crosshairs: true,
  },
  // legend: {
  //   enabled: false,
  // },
  series: [
    // {
    //   type: "line",
    //   name: "TB",
    //   data: [],
    // },
    // {
    //   type: "line",
    //   name: "TR",
    //   data: [],
    // },
  ],
};

const menu = (exportFileAs, deleteWorkspace) => (
  <Menu className="w-32">
    <SubMenu title="Download" className="w-32" key="chart-type">
      <Menu.Item key="png" onClick={() => exportFileAs("image/png")}>
        png
      </Menu.Item>
      <Menu.Item key="jpeg" onClick={() => exportFileAs("image/jpeg")}>
        jpeg
      </Menu.Item>
      <Menu.Item key="pdf" onClick={() => exportFileAs("application/pdf")}>
        pdf
      </Menu.Item>
      <Menu.Item key="svg" onClick={() => exportFileAs("image/svg+xml")}>
        svg
      </Menu.Item>
    </SubMenu>
    <Menu.Item key="menu-delete" onClick={() => deleteWorkspace()}>
      Delete
    </Menu.Item>
  </Menu>
);

const dates = ["Last Day", "Last 7 Days", "Last 2 Weeks", "Last 3 Weeks", "Last 30 Days"];

const WorkspaceItem = ({ data, handleRemove }) => {
  const chartRef = useRef(null);
  const { data: kpis } = useSelector((state) => state.kpis);

  function exportFileAs(output) {
    if (chartRef.current) {
      chartRef.current.chart.exportChart({
        type: output,
      });
    } else {
      toast.error("Chart Not Found");
    }
  }

  async function deleteWorkspace() {
    try {
      await workspaceService.deleteWorkspace(data._id);
      handleRemove(data._id);
    } catch (error) {
      toast.error("Action has error");
      console.log(error);
    }
  }

  useEffect(() => {
    if (
      chartRef &&
      chartRef.current &&
      data &&
      data.hasOwnProperty("kpi_query_list") &&
      data.kpi_query_list.length
    ) {
      const counters = JSON.parse(data.kpi_query_list);

      const seriesLength = chartRef.current.chart.series.length;

      for (var i = seriesLength - 1; i > -1; i--) {
        const id = chartRef.current.chart.series[i].options.id;

        if (!counters || !counters.length) {
          chartRef.current.chart.series[i].remove();
        } else if (!(counters.findIndex((x) => x.id === id) > -1)) {
          chartRef.current.chart.series[i].remove();
        }
      }

      // eslint-disable-next-line array-callback-return
      counters.map(async (counter, i) => {
        try {
          const res = await performanceManagementService.fetchKpi({
            startDate: counter.startDate,
            endDate: counter.endDate,
            scope: counter.scope,
            kpi_id: counter.kpi_id,
            value: counter.value,
            buket: counter.buket,
          });

          const name =
            (kpis.findIndex((x) => x._id === counter.kpi_id) > -1
              ? kpis.find((x) => x._id === counter.kpi_id).name ||
                counter.kpi_id
              : counter.kpi_id) +
            ` - ${counter.buket} - ${counter.value} (${
              dates.includes(counter.startDate)
                ? `${counter.startDate}`
                : `${counter.startDate} -> ${counter.endDate}`
            })`;

          if (chartRef.current.chart.get(counter.id)) {
            const series = chartRef.current.chart.get(counter.id);
            series.update({
              type: counter.type,
              id: counter.id,
              yAxis: counter.align.y,
              xAxis: counter.align.x,
              visible: counter.show,
              color: counter.color,
              name,
              data: res.data.reduce((result, item) => {
                const myDate = new Date(item.datetime);
                const result2 = myDate.getTime();

                result.push([
                  result2,
                  item.kpi === null
                    ? null
                    : Number(Number(item.kpi).toFixed(4)),
                ]);

                return result;
              }, []),
            });

            if (counter.counters.length) {
              counter.counters.forEach((c) => {
                chartRef.current.chart.addSeries({
                  showInLegend: false,
                  type: counter.type,
                  id: counter.id + "_" + c,
                  visible: counter.counterShow,
                  yAxis: counter.align.y,
                  xAxis: counter.align.x,
                  name: name + "_" + c,
                  color: counter.color,
                  data: res.data.reduce((result, item) => {
                    const myDate = new Date(item.datetime);
                    const result2 = myDate.getTime();

                    result.push([
                      result2,
                      item.kpi === null
                        ? null
                        : Number(Number(item[c]).toFixed(4)),
                    ]);

                    return result;
                  }, []),
                });
              });
            }
          } else {
            chartRef.current.chart.addSeries({
              type: counter.type,
              id: counter.id,
              visible: counter.show,
              yAxis: counter.align.y,
              xAxis: counter.align.x,
              name,
              color: counter.color,
              data: res.data.reduce((result, item) => {
                const myDate = new Date(item.datetime);
                const result2 = myDate.getTime();

                result.push([
                  result2,
                  item.kpi === null
                    ? null
                    : Number(Number(item.kpi).toFixed(4)),
                ]);

                return result;
              }, []),
            });

            if (counter.counters.length) {
              counter.counters.forEach((c) => {
                chartRef.current.chart.addSeries({
                  showInLegend: false,
                  type: counter.type,
                  id: counter.id + "_" + c,
                  visible: counter.counterShow,
                  yAxis: counter.align.y,
                  xAxis: counter.align.x,
                  name: name + "_" + c,
                  color: counter.color,
                  data: res.data.reduce((result, item) => {
                    const myDate = new Date(item.datetime);
                    const result2 = myDate.getTime();

                    result.push([
                      result2,
                      item.kpi === null
                        ? null
                        : Number(Number(item[c]).toFixed(4)),
                    ]);

                    return result;
                  }, []),
                });
              });
            }
          }
        } catch (e) {
          console.log(e);
        }
      });
    }
    // eslint-disable-next-line
  }, [data]);

  return (
    <div
      className={`flex flex-col mt-3 bg-white border border-gray-200 rounded p-5 pt-7`}
    >
      <div className="flex justify-between items-center mb-12 px-2">
        <h5 className="text-gray-750 mb-0">{data.name}</h5>

        <ConfigProvider direction="rtl">
          <Dropdown
            overlay={menu(exportFileAs, deleteWorkspace)}
            trigger={["click"]}
            placeholder="bottomRight"
            className="cursor-pointer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 text-gray-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
              />
            </svg>
          </Dropdown>
        </ConfigProvider>
      </div>

      <HighchartsReact
        ref={chartRef}
        highcharts={Highcharts}
        options={options}
      />
    </div>
  );
};

export default WorkspaceItem;
